module.exports = __webpack_public_path__ + "img/bank-muamalat-img.84effe08.png";